import {DomainEvent, createDomainEvent} from './domain-event'

/**
 * Favourite Domain Events
 *
 * Events related to user favourites/wishlist operations
 */

// Event Types
export const FavouriteEventTypes = {
  ProductAdded: 'favourite.product_added',
  ProductRemoved: 'favourite.product_removed',
  ListCleared: 'favourite.list_cleared',
  ListLoaded: 'favourite.list_loaded',
} as const

// Payload Types
export interface FavouriteProductAddedPayload {
  productId: Id
  userId?: string
}

export interface FavouriteProductRemovedPayload {
  productId: Id
  userId?: string
}

export interface FavouriteListClearedPayload {
  userId?: string
  previousCount: number
}

export interface FavouriteListLoadedPayload {
  productIds: Id[]
  userId?: string
}

// Event Types
export type FavouriteProductAddedEvent = DomainEvent<FavouriteProductAddedPayload>
export type FavouriteProductRemovedEvent = DomainEvent<FavouriteProductRemovedPayload>
export type FavouriteListClearedEvent = DomainEvent<FavouriteListClearedPayload>
export type FavouriteListLoadedEvent = DomainEvent<FavouriteListLoadedPayload>

// Event Factories
export const FavouriteEvents = {
  productAdded(payload: FavouriteProductAddedPayload): FavouriteProductAddedEvent {
    return createDomainEvent(FavouriteEventTypes.ProductAdded, payload, payload.userId)
  },

  productRemoved(payload: FavouriteProductRemovedPayload): FavouriteProductRemovedEvent {
    return createDomainEvent(FavouriteEventTypes.ProductRemoved, payload, payload.userId)
  },

  listCleared(payload: FavouriteListClearedPayload): FavouriteListClearedEvent {
    return createDomainEvent(FavouriteEventTypes.ListCleared, payload, payload.userId)
  },

  listLoaded(payload: FavouriteListLoadedPayload): FavouriteListLoadedEvent {
    return createDomainEvent(FavouriteEventTypes.ListLoaded, payload, payload.userId)
  },
}
